import { render, staticRenderFns } from "./BookingModalComponent.vue?vue&type=template&id=13498b7f"
import script from "./BookingModalComponent.vue?vue&type=script&lang=js"
export * from "./BookingModalComponent.vue?vue&type=script&lang=js"
import style0 from "./BookingModalComponent.vue?vue&type=style&index=0&id=13498b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports